export default __webpack_public_path__ + "static/media/reactjs.f153eb9f.png";